import { useState } from "react";
import { Navigate, useNavigate } from "react-router";
import styled from "styled-components";
import { StyledButton } from "../../../../../components/Button/button";
import { theme } from "../../../../../helpers/theme";
import { url } from "../../../../../utils/url";
import { StyledPopover } from "../../../unlogged-dashboard/form-bar/styled-popover";

interface SummaryButtonProps {
  isDisabled: boolean;
}

const SummaryButton = ({ isDisabled }: SummaryButtonProps) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (isDisabled) setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <StyledButtonWrapper
        onMouseEnter={(e) => handlePopoverOpen(e)}
        onMouseLeave={handlePopoverClose}
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
      >
        <StyledButton
          type="submit"
          variant="contained"
          sx={{ height: "56px", width: "226px" }}
          disabled={isDisabled}
        >
          Przejdź do podsumowania
        </StyledButton>
      </StyledButtonWrapper>
      <StyledPopover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <InfoPopoverContentContainer>
          Popraw błędnie uzupełnione pola
        </InfoPopoverContentContainer>
      </StyledPopover>
    </>
  );
};

export default SummaryButton;
const InfoPopoverContentContainer = styled.div`
  padding: 10px;
  background-color: white;
  font-family: ${theme.fonts.interMedium};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
const StyledButtonWrapper = styled.div`
  width: 200px;
  height: 60px;
`;
